import { Directive, TemplateRef } from '@angular/core';

/**
 * Marks an ng-template as the header content of an immo-menu.
 *
 * Usage:
 * ```html
 * <immo-menu [actions]="actions" triggerAriaLabel="Profilmenü">
 *     <ng-template immoMenuHeader>
 *         <span class="name">{{ userName() }}</span>
 *         <span class="email">{{ email() }}</span>
 *     </ng-template>
 * </immo-menu>
 * ```
 */
@Directive({ selector: '[immoMenuHeader]' })
export class MenuHeaderDirective {
    // -----------------------------------------------------------------------------------------------------
    // @ CONSTRUCTOR
    // -----------------------------------------------------------------------------------------------------

    constructor(public readonly template: TemplateRef<unknown>) {
    }
}
